export default {
  CREATE: `Créer une règle de carte de temps`,
  DELETE_BUTTON: {
    TITLE: `Supprimer la règle de carte de temps`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette règle de carte de temps ?`,
    PRIMARY_ACTION: `Supprimer la règle de carte de temps`
  },
  LIST: {
    TITLE: `Liste des règles de carte de temps`
  },
  CSV_EXPORT_NAME: `export_positions_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Création d'une règle de carte de temps`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'une règle de carte de temps`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom de la règle de carte de temps`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom pour la règle de carte de temps`
    },
    OVERTIME_RULES: `Règles de temps supplémentaire`,
    OVERTIMEWAGEPREMIUMID: {
      LABEL: `Code de prime`,
      DESCRIPTION: ``
    },
    OVERTIMETHRESHOLDDAY: {
      LABEL: `Seuil par jour`,
      DESCRIPTION: `Les cartes de temps ayant plus de ce nombre d'heures verront leurs heures excédentes transformées en temps supplémentaire.`,
      PLACEHOLDER: `Entrez une valeur entre 0 et 24`
    },
    OVERTIMETHRESHOLDWEEK: {
      LABEL: `Seuil par semaine`,
      DESCRIPTION: `Les dernières cartes de temps modifiées dans la semaine verront leurs heures excédentes transformées en temps supplémentaire.`,
      PLACEHOLDER: `Entrez une valeur entre 0 et 168`
    },
    NAME_REQUIRED: `Le nom de la règle de carte de temps est obligatoire.`,
    TRANSFER_RULES: `Règle d'arrondissement des transferts`,
    BREAK_RULES: `Règle d'arrondissement des pauses`,
    AUTO_APPROVED_ARRIVAL: `Entrée approuvée automatiquement`,
    AUTO_APPROVED_LEAVE: `Sortie approuvée automatiquement`,
    DANGER_START_RULE: `Si l'heure d'entrée ne correspond pas à ce qui était prévu, l'approbation d'un responsable sera nécessaire. Lorsqu'approuvée, `,
    DANGER_END_RULE: `Si l'heure de sortie ne correspond pas à ce qui était prévu, l'approbation d'un responsable sera nécessaire. Lorsqu'approuvée, `,
    ROUND_5: `et l'arrondir aux 5 minutes`,
    ROUND_15: `et l'arrondir aux 15 minutes`,
    TO_SHIFT: `et l'arrondir à l'heure du quart`,
    NO_ROUND: `et ne pas arrondir`,
    MIN_BEFORE_START: ` minutes avant le début du quart `,
    MIN_AFTER_START: ` minutes après le début du quart `,
    MIN_BEFORE_END: ` minutes avant la fin du quart `,
    MIN_AFTER_END: ` minutes après la fin du quart `,
    dangerRounding: {
      ROUND_5: `arrondissez aux 5 minutes`,
      ROUND_15: `arrondissez aux 15 minutes`,
      TO_SHIFT: `arrondissez à l'heure du quart`,
      NO_ROUND: `n'arrondissez pas`
    }
  },
  TRANSFER_ACTION: `Transfert`,
  BREAK_ACTION: `Pause`,
  ROUND_5: `Arrondir aux 5 minutes`,
  ROUND_15: `Arrondir aux 15 minutes`,
  TO_SHIFT: `Arrondir au quart`,
  NO_ROUND: `Ne pas arrondir`
}
